import React from "react";
import Loading from "components/Loading";
import styles from "./Table.module.css";

type Props = {
  loading?: boolean;
  childrenThead?: any;
  childrenTbody?: any;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Table: React.FC<Props> = ({
  loading,
  childrenThead,
  childrenTbody,
}): JSX.Element => {
  return (
    <div className="overflow-x-auto relative">
      {loading && <Loading loading={loading} />}
      <table className="w-full mt-10 border-separate border-spacing-y-4">
        <thead className={styles.thead}>{childrenThead}</thead>
        <tbody className={styles.tbody}>
          {childrenTbody ? (
            childrenTbody
          ) : (
            <tr>
              <th
                scope="row"
                colSpan={7}
                className="flex items-center justify-center"
              >
                No data
              </th>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
